module.exports = __webpack_public_path__ + "img/service3.c15caf30.jpg";